import React from 'react';
import { Input } from 'baseui/input';
import { MIcon } from '../Icon';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const { overrides, size = 'default', ...rest } = props;

	const _iconSize =
		props.size === 'large' ? 'var(--epods--button-large-icon-size)' : 'var(--epods--button-default-icon-size)';

	return (
		<Input
			inputRef={ref}
			{...rest}
			size={size}
			overrides={
				overrides
					? mergeOverrides(
						customOverrides(rest, HTMLAttrs.dataProps, HTMLAttrs.ariaProps, HTMLAttrs.rest),
						overrides as any,
					)
					: customOverrides(rest, HTMLAttrs.dataProps, HTMLAttrs.ariaProps, HTMLAttrs.rest)
			}
			endEnhancer={
				props.iconAfter ? (
					<MIcon
						icon={props.iconAfter}
						size={_iconSize}
						color={
							props.disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--color-text-primary)'
						}
						aria-hidden="true"
						// @ts-ignore - // TODO: Check with Joao
						focusable={false}
					/>
				) : (
					props.endEnhancer
				)
			}
			startEnhancer={
				props.iconBefore ? (
					<MIcon
						icon={props.iconBefore}
						size={_iconSize}
						color={
							props.disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--color-text-primary)'
						}
						aria-hidden="true"
						focusable={false}
					/>
				) : (
					props.startEnhancer
				)
			}
		/>
	);
});
